const TUI_JAPAN_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['番号', 'カード番号'],
  cardExpiry: ['期限切れ', '有効期間']
};
const TUI_JAPAN_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['ソリッドカラー', '勾配'],
  toolbarTools: {
    undo: '元に戻す',
    redo: 'やり直す',
    font: 'フォント',
    fontStyle: 'フォントスタイル',
    fontSize: 'フォントサイズ',
    bold: '大胆な',
    italic: 'イタリック',
    underline: '下線',
    strikeThrough: '取り消し線',
    justify: '正当化する',
    justifyLeft: '左揃え',
    justifyCenter: '中央揃え',
    justifyRight: '右揃え',
    justifyFull: '両端揃え',
    list: 'リスト',
    indent: 'インデント',
    outdent: 'アウトデント',
    unorderedList: '順序なしリスト',
    orderedList: '順序付きリスト',
    quote: '引用',
    foreColor: '色',
    backColor: '背景色',
    hiliteColor: 'ハイライトカラー',
    clear: 'クリア',
    link: 'リンク',
    attach: 'ファイルを添付する',
    tex: 'テキストを挿入',
    code: 'コード',
    image: '画像を挿入',
    insertHorizontalRule: '水平線を挿入',
    superscript: '上付き文字',
    subscript: '添字',
    insertTable: '表を挿入',
    insertGroup: 'グループを挿入',
    hiliteGroup: 'ハイライトグループ',
    removeGroup: 'グループを削除',
    insertAnchor: 'アンカーを挿入',
    mergeCells: 'セルを結合します',
    splitCells: 'セルを分割する',
    rowsColumnsManaging: '行と列の管理',
    cellColor: 'セルの色',
    setDetails: '詳細',
    removeDetails: '詳細を削除'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'アンカー'
  },
  editorTableCommands: [['前に列を挿入', '列を挿入'], ['前に行を挿入', '行を挿入'], ['列を削除', '行を削除']],
  editorCodeOptions: ['テキスト内のコード', 'ブロック内のコード'],
  editorFontOptions: {
    small: '小さい',
    large: '大きい',
    normal: '普通',
    title: 'タイトル',
    subtitle: '字幕'
  }
};
const TUI_JAPAN_LANGUAGE_ADDON_TABLE = {
  showHideText: '表示または非表示',
  paginationTexts: {
    pages: 'ページ',
    linesPerPage: '1ページあたりの行数',
    of: 'の'
  }
};
const TUI_JAPAN_LANGUAGE_COUNTRIES = {
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua & Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AR: 'Argentina',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AZ: 'Azerbaijan',
  BA: 'Bosnia & Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'St. Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei',
  BO: 'Bolivia',
  BQ: 'Caribbean Netherlands',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CD: 'Congo - Kinshasa',
  CF: 'Central African Republic',
  CG: 'Congo - Brazzaville',
  CH: 'Switzerland',
  CI: 'Côte d’Ivoire',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cape Verde',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands',
  FM: 'Federated States of Micronesia',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GT: 'Guatemala',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IN: 'India',
  IQ: 'Iraq',
  IR: 'Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KM: 'Comoros',
  KN: 'St. Kitts & Nevis',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: 'Laos',
  LB: 'Lebanon',
  LC: 'St. Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova',
  ME: 'Montenegro',
  MF: 'St. Martin',
  MG: 'Madagascar',
  MK: 'North Macedonia',
  ML: 'Mali',
  MM: 'Myanmar (Burma)',
  MN: 'Mongolia',
  MO: 'Macao',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russia',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'St. Helena',
  SI: 'Slovenia',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'São Tomé & Príncipe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Syria',
  SZ: 'Eswatini',
  TC: 'Turks & Caicos Islands',
  TD: 'Chad',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Türkiye',
  TT: 'Trinidad & Tobago',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ukraine',
  UG: 'Uganda',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VC: 'St. Vincent & Grenadines',
  VE: 'Venezuela',
  VG: 'British Virgin Islands',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_JAPAN_LANGUAGE_CORE = {
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  close: '近い',
  clear: 'フィールドをクリアする',
  nothingFoundMessage: '何も見つかりません',
  defaultErrorMessage: '値が無効です',
  spinTexts: ['前の', '次'],
  shortWeekDays: ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'],
  countries: TUI_JAPAN_LANGUAGE_COUNTRIES
};
const TUI_JAPAN_LANGUAGE_KIT = {
  cancel: 'キャンセル',
  done: '終わり',
  more: 'もっと',
  otherDate: 'その他の日付',
  showAll: 'すべて表示する',
  hide: '隠れる',
  mobileCalendarTexts: ['日付を選択', '範囲を選択', '日数を選択'],
  range: ['から', 'に'],
  countTexts: ['プラス', 'マイナス'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['パスワードを表示', 'パスワードを隠す'],
  copyTexts: ['コピー', 'コピーしました'],
  shortCalendarMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  pagination: ['前のページ', '次のページ'],
  fileTexts: {
    loadingError: 'アップロードに失敗しました',
    preview: 'プレビュー',
    remove: '取り除く'
  },
  inputFileTexts: {
    defaultLabelSingle: 'またはここにドロップしてください',
    defaultLabelMultiple: 'またはここにドロップしてください',
    defaultLinkSingle: 'ファイルを選択',
    defaultLinkMultiple: 'ファイルを選択',
    maxSizeRejectionReason: 'ファイルはより大きいです',
    formatRejectionReason: 'ファイルタイプが間違っています',
    drop: 'ここにファイルをドロップ',
    dropMultiple: 'ここにファイルをドロップ'
  },
  multiSelectTexts: {
    all: 'すべて選択',
    none: '何も選択しない'
  },
  confirm: {
    yes: 'はい',
    no: 'しかし'
  },
  previewTexts: {
    rotate: '回転'
  },
  zoomTexts: {
    zoomOut: 'ズームアウトする',
    zoomIn: 'ズームイン',
    reset: 'リセット'
  },
  phoneSearch: '国またはコードを入力'
};
const TUI_JAPAN_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};

// TODO: Rename to JAPANESE in v5
const TUI_JAPAN_LANGUAGE = {
  name: 'japan',
  ...TUI_JAPAN_LANGUAGE_CORE,
  ...TUI_JAPAN_LANGUAGE_KIT,
  ...TUI_JAPAN_LANGUAGE_ADDON_TABLE,
  ...TUI_JAPAN_LANGUAGE_ADDON_COMMERCE,
  ...TUI_JAPAN_LANGUAGE_ADDON_EDITOR,
  ...TUI_JAPAN_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_JAPAN_LANGUAGE, TUI_JAPAN_LANGUAGE_ADDON_COMMERCE, TUI_JAPAN_LANGUAGE_ADDON_EDITOR, TUI_JAPAN_LANGUAGE_ADDON_TABLE, TUI_JAPAN_LANGUAGE_CORE, TUI_JAPAN_LANGUAGE_COUNTRIES, TUI_JAPAN_LANGUAGE_KIT, TUI_JAPAN_LANGUAGE_LAYOUT };
